var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "entry-layout-menus-item",
      class: {
        "entry-layout-menus-item--active": _vm.activeKey === _vm.menu.key
      }
    },
    [
      _c("div", { staticClass: "entry-layout-menus-item__hd" }, [
        _c(
          "div",
          { staticClass: "entry-layout-menus-item__title" },
          [
            _vm.menu.icon && ~_vm.menu.icon.indexOf("http")
              ? _c("img", {
                  staticClass: "entry-layout-menus-item__thumb",
                  attrs: { src: _vm.menu.icon }
                })
              : _vm.menu.icon && ~_vm.menu.icon.indexOf("gb-icon-")
              ? _c("icon-font", {
                  staticClass: "entry-layout-menus-item__thumb",
                  attrs: { type: _vm.menu.icon }
                })
              : _c("a-icon", {
                  staticClass: "entry-layout-menus-item__thumb",
                  attrs: { type: _vm.menu.icon || "thunderbolt" }
                }),
            _c("span", [_vm._v(_vm._s(_vm._f("menuLocalName")(_vm.menu)))])
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "entry-layout-menus-item__bd" },
        [
          _vm.menu.childMenus.filter(function(item) {
            return item.lastMenu === 2
          }).length
            ? [
                _c(
                  "div",
                  { staticClass: "entry-layout-menus-item__children" },
                  [
                    _vm._l(
                      _vm.menu.childMenus.filter(function(item) {
                        return (
                          item.lastMenu === 2 &&
                          (_vm.paidPageFlag === 2
                            ? true
                            : item.updateFlag === 1)
                        )
                      }),
                      function(level2) {
                        return [
                          _c(
                            "div",
                            {
                              key: level2.key,
                              staticClass:
                                "entry-layout-menus-item__text entry-layout-menus-item__text--link"
                            },
                            [
                              level2["icon"]
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "entry-layout-menus-item__text--link__icon"
                                    },
                                    [
                                      /^http/.test(level2["icon"])
                                        ? _c("img", {
                                            attrs: { src: level2["icon"] }
                                          })
                                        : /^gb/.test(level2["icon"])
                                        ? _c("icon-font", {
                                            attrs: { type: level2.icon }
                                          })
                                        : _c("a-icon", {
                                            attrs: { type: level2.icon }
                                          })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "span",
                                {
                                  class: {
                                    "text-disabled": level2.updateFlag === 2
                                  },
                                  on: {
                                    click: function($event) {
                                      level2.updateFlag === 1 &&
                                        _vm.onClick(level2.key)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("menuLocalName")(level2))
                                  )
                                ]
                              ),
                              level2.updateFlag === 1
                                ? [
                                    ~_vm.favoriteKeys.indexOf(level2.key)
                                      ? _c("a-icon", {
                                          directives: [
                                            {
                                              name: "demo",
                                              rawName: "v-demo:[level2.key]",
                                              value: "delFavorites",
                                              expression: "'delFavorites'",
                                              arg: level2.key
                                            }
                                          ],
                                          staticStyle: {
                                            display: "block",
                                            color: "#5681F4"
                                          },
                                          attrs: {
                                            type: "star",
                                            theme: "filled"
                                          }
                                        })
                                      : _c("a-icon", {
                                          directives: [
                                            {
                                              name: "demo",
                                              rawName: "v-demo:[level2.key]",
                                              value: "addFavorites",
                                              expression: "'addFavorites'",
                                              arg: level2.key
                                            }
                                          ],
                                          attrs: { type: "star" }
                                        })
                                  ]
                                : _c(
                                    "a-button",
                                    {
                                      directives: [
                                        {
                                          name: "demo",
                                          rawName: "v-demo:[level2]",
                                          value: "toUpgradePage",
                                          expression: "'toUpgradePage'",
                                          arg: level2
                                        }
                                      ],
                                      staticClass: "buy-btn",
                                      staticStyle: {
                                        "font-size": "12px",
                                        padding: "0"
                                      },
                                      attrs: { type: "link", size: "small" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("layouts.buy")))]
                                  )
                            ],
                            2
                          )
                        ]
                      }
                    )
                  ],
                  2
                )
              ]
            : _vm._e(),
          _vm._l(
            _vm.menu.childMenus.filter(function(item) {
              return item.lastMenu !== 2
            }),
            function(level2) {
              return [
                _c(
                  "div",
                  {
                    key: level2.key,
                    staticClass: "entry-layout-menus-item__children"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "entry-layout-menus-item__text entry-layout-menus-item__text--blod"
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("menuLocalName")(level2)))
                        ])
                      ]
                    ),
                    _vm._l(
                      level2.childMenus.filter(function(item) {
                        return _vm.paidPageFlag === 2
                          ? true
                          : item.updateFlag === 1
                      }),
                      function(level3) {
                        return [
                          level3.lastMenu === 2
                            ? [
                                _c(
                                  "div",
                                  {
                                    key: level3.key,
                                    staticClass:
                                      "entry-layout-menus-item__text entry-layout-menus-item__text--link"
                                  },
                                  [
                                    level3.lastMenu === 2 && level3["icon"]
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "entry-layout-menus-item__text--link__icon"
                                          },
                                          [
                                            /^http/.test(level3["icon"])
                                              ? _c("img", {
                                                  attrs: { src: level3["icon"] }
                                                })
                                              : /^gb/.test(level3["icon"])
                                              ? _c("icon-font", {
                                                  attrs: { type: level3.icon }
                                                })
                                              : _c("a-icon", {
                                                  attrs: { type: level3.icon }
                                                })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        class: {
                                          "text-disabled":
                                            level3.updateFlag === 2
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onClick(level3.key)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("menuLocalName")(level3)
                                          )
                                        )
                                      ]
                                    ),
                                    level3.updateFlag === 1
                                      ? [
                                          ~_vm.favoriteKeys.indexOf(level3.key)
                                            ? _c("a-icon", {
                                                directives: [
                                                  {
                                                    name: "demo",
                                                    rawName:
                                                      "v-demo:[level3.key]",
                                                    value: "delFavorites",
                                                    expression:
                                                      "'delFavorites'",
                                                    arg: level3.key
                                                  }
                                                ],
                                                staticStyle: {
                                                  display: "block",
                                                  color: "#5681F4"
                                                },
                                                attrs: {
                                                  type: "star",
                                                  theme: "filled"
                                                }
                                              })
                                            : _c("a-icon", {
                                                directives: [
                                                  {
                                                    name: "demo",
                                                    rawName:
                                                      "v-demo:[level3.key]",
                                                    value: "addFavorites",
                                                    expression:
                                                      "'addFavorites'",
                                                    arg: level3.key
                                                  }
                                                ],
                                                attrs: { type: "star" }
                                              })
                                        ]
                                      : _c(
                                          "a-button",
                                          {
                                            directives: [
                                              {
                                                name: "demo",
                                                rawName: "v-demo:[level3]",
                                                value: "toUpgradePage",
                                                expression: "'toUpgradePage'",
                                                arg: level3
                                              }
                                            ],
                                            staticClass: "buy-btn",
                                            staticStyle: {
                                              "font-size": "12px",
                                              padding: "0"
                                            },
                                            attrs: {
                                              type: "link",
                                              size: "small"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("layouts.buy"))
                                            )
                                          ]
                                        )
                                  ],
                                  2
                                )
                              ]
                            : level3.childMenus.length
                            ? [
                                _c(
                                  "div",
                                  {
                                    key: level3.key,
                                    staticClass: "entry-layout-menus-item__text"
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm._f("menuLocalName")(level3))
                                      )
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "entry-layout-menus-item__children"
                                      },
                                      [
                                        _vm._l(
                                          level3.childMenus.filter(function(
                                            item
                                          ) {
                                            return _vm.paidPageFlag === 2
                                              ? true
                                              : item.updateFlag === 1
                                          }),
                                          function(level4) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  key: level4.key,
                                                  staticClass:
                                                    "entry-layout-menus-item__text entry-layout-menus-item__text--link"
                                                },
                                                [
                                                  level4.lastMenu === 2 &&
                                                  level4["icon"]
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "entry-layout-menus-item__text--link__icon"
                                                        },
                                                        [
                                                          /^http/.test(
                                                            level4["icon"]
                                                          )
                                                            ? _c("img", {
                                                                attrs: {
                                                                  src:
                                                                    level4[
                                                                      "icon"
                                                                    ]
                                                                }
                                                              })
                                                            : /^gb/.test(
                                                                level4["icon"]
                                                              )
                                                            ? _c("icon-font", {
                                                                attrs: {
                                                                  type:
                                                                    level4.icon
                                                                }
                                                              })
                                                            : _c("a-icon", {
                                                                attrs: {
                                                                  type:
                                                                    level4.icon
                                                                }
                                                              })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        "text-disabled":
                                                          level4.updateFlag ===
                                                          2
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.onClick(
                                                            level4.key
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "menuLocalName"
                                                          )(level4)
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  level4.updateFlag === 1
                                                    ? [
                                                        ~_vm.favoriteKeys.indexOf(
                                                          level4.key
                                                        )
                                                          ? _c("a-icon", {
                                                              directives: [
                                                                {
                                                                  name: "demo",
                                                                  rawName:
                                                                    "v-demo:[level4.key]",
                                                                  value:
                                                                    "delFavorites",
                                                                  expression:
                                                                    "'delFavorites'",
                                                                  arg:
                                                                    level4.key
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                display:
                                                                  "block",
                                                                color: "#5681F4"
                                                              },
                                                              attrs: {
                                                                type: "star",
                                                                theme: "filled"
                                                              }
                                                            })
                                                          : _c("a-icon", {
                                                              directives: [
                                                                {
                                                                  name: "demo",
                                                                  rawName:
                                                                    "v-demo:[level4.key]",
                                                                  value:
                                                                    "addFavorites",
                                                                  expression:
                                                                    "'addFavorites'",
                                                                  arg:
                                                                    level4.key
                                                                }
                                                              ],
                                                              attrs: {
                                                                type: "star"
                                                              }
                                                            })
                                                      ]
                                                    : _c(
                                                        "a-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "demo",
                                                              rawName:
                                                                "v-demo:[level4]",
                                                              value:
                                                                "toUpgradePage",
                                                              expression:
                                                                "'toUpgradePage'",
                                                              arg: level4
                                                            }
                                                          ],
                                                          staticClass:
                                                            "buy-btn",
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            padding: "0"
                                                          },
                                                          attrs: {
                                                            type: "link",
                                                            size: "small"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "layouts.buy"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                ],
                                                2
                                              )
                                            ]
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ]
                      }
                    )
                  ],
                  2
                )
              ]
            }
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }